module.exports = __webpack_public_path__ + "static/media/document.091cfb41.svg";